const { version } = require('../../package.json');
const FIREBASE = require('./config-fb-prod');

module.exports = {
  ENV: 'production',
  FIREBASE,
  API_URL: 'https://api.collarapp.uk/graphql',
  SUB_API_URL: 'wss://api.collarapp.uk/graphql',
  CLIENT_ID: `APP-${version}`,
  STRIPE_PUB_KEY: 'pk_live_51HUs4kKwlInnaEqsAvotgacHBo5ypl55iLG4V2Tg72bCcY15VqoiGq47NoAe6VR1qJiQW8amvdrv6o9AlRksTu1f00TtVAgWfO',
  RECAPTCHA_SITE_KEY: '6LcOWQMhAAAAALNGNmUAfeCSHFu9GsS5GyIbKXAC',
  APP_URL: 'https://app.collar.pet',
  APP_ALIAS_URLS: ['https://book.collarapp.uk', 'https://book.collar.pet', 'https://app.collarapp.uk'],
  APP_IOS_URL: 'https://apps.apple.com/app/Collar/id1535869072',
  APP_ANDROID_URL: 'https://play.google.com/store/apps/details?id=com.layers.collar',
  ROLLBAR_KEY: 'd1f231a9e57e47f9bd9cc6da9f724ba6',
  ROLLBAR_ENV: 'production'
};
